import React from 'react';
import SuperToolLogo from './SuperToolLogo';

const Footer = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-background border-t border-[#181818]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <SuperToolLogo size={28} animated={false} />
              <span className="text-lg font-bold text-foreground">SuperTool AI</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              The AI-powered platform that turns your ideas into production-ready apps.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Product</h4>
            <ul className="space-y-3">
              {[
                { label: 'Features', action: () => scrollTo('features') },
                { label: 'Pricing', action: () => scrollTo('pricing') },
                { label: 'Templates', action: () => window.location.href = '/templates' },
                { label: 'Enterprise', action: () => scrollTo('enterprise') },
                { label: 'Changelog', action: () => {} }
              ].map((item) => (
                <li key={item.label}>
                  <button onClick={item.action} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Resources</h4>
            <ul className="space-y-3">
              {['Documentation', 'API Reference', 'Community', 'Blog', 'Support'].map((item) => (
                <li key={item}>
                  <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-3">
              {[
                { label: 'Privacy Policy', href: '/privacy' },
                { label: 'Terms of Service', href: '/terms' },
                { label: 'Cookie Policy', href: '#' },
                { label: 'Security', href: '#' },
                { label: 'GDPR', href: '#' }
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid={`footer-${item.label.toLowerCase().replace(/\s+/g, '-')}`}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-[#181818] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} SuperTool AI. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {['Twitter', 'GitHub', 'Discord', 'LinkedIn'].map((social) => (
              <button key={social} className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid={`social-${social.toLowerCase()}`}>
                {social}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
